import React from 'react'

export const Radio = ({ name, value, checked, label, labelClassName, disabled, onChange }) => {
    const className = 'form-check-input' + ( checked ? ' checked' : '' )
    return (
        <label className="display-block" key={value}>
            <input
                type="radio"
                className={className}
                name={name}
                value={value}
                checked={checked}
                disabled={disabled}
                onChange={onChange}
            />
            <span dangerouslySetInnerHTML={{__html: label}}></span>
        </label>
    )
}

export const RadioGroup = ({ name, value, onChange, options }) => {
    return (
        <div>
            {options.map((option) => (
                 <Radio
                     key={option.value}
                     name={name}
                     value={option.value}
                     label={option.label}
                     checked={value === option.value}
                     disabled={option.disabled}
                     onChange={(e) => onChange(e.target.value)}
                 />
             ))}
        </div>
    );
}
